import ForgotPassword from '../../hooks/ForgotPassword';
import Email from './Email';
import Send from './Send';
import Return from './Return';

const ForgotPasswordForm = ({ onBackToLogin, logout, message }) => {
  const vm = ForgotPassword({logout, message})

  return (
    <div className="mx-auto bg-white shadow-md p-6 w-full max-w-[18rem]">
      <h2 className="text-2xl text-center mb-6">Recuperar contraseña</h2>
      <form onSubmit={vm.handleSubmit} className="space-y-6">
        <Email email={vm.email} setEmail={vm.setEmail} />
        <Send loading={vm.loading} />
      </form>
      <Return onBackToLogin={onBackToLogin} />
    </div>
  );
};

export default ForgotPasswordForm;
